import { render, staticRenderFns } from "./CoTwoPremiseForm.vue?vue&type=template&id=0f92c7e4&"
import script from "./CoTwoPremiseForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoPremiseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports